import { isNil } from 'es-toolkit';

import { HOUSEHOLD_PROSPECTING_STAGES } from '@savvy/constants/household-stages';

import type { BaseClient, BaseHousehold, BaseProspectData, BaseUser } from './shared';

export type Household = BaseHousehold & {
  readonly salesforceAccountId?: string | null;
  readonly uuid: string;
  readonly advisorAnnualRevenue: string | null;
  readonly prospectData: BaseProspectData | null;
  readonly primaryClient: BaseClient | null;
  readonly coClient: BaseClient | null;
};

export function isProspect(household: Household): boolean {
  if (isNil(household.householdStage)) return false;
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return HOUSEHOLD_PROSPECTING_STAGES.includes(household.householdStage as never);
}

// Re-export shared types for backward compatibility
export type HouseholdUser = BaseUser;
export type HouseholdClient = BaseClient;
export type HouseholdProspectData = BaseProspectData;
